const ungroup = value => String(value == null ? '' : value).replace(/[ \u00a0\u202f]/g, '');
const normalize = value => ungroup(value).replace(',', '.');

function format(value) {
    const raw = ungroup(value);
    if (!/^\d*([.,]\d*)?$/.test(raw)) return String(value == null ? '' : value);
    const parts = raw.split(/[.,]/);
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (parts.length > 1 ? ',' + parts[1] : '');
}

function caret(value, significantCharacters) {
    let position = 0, count = 0;
    while (position < value.length && count < significantCharacters) {
        if (value[position] !== ' ') count++;
        position++;
    }
    return position;
}

module.exports = {ungroup, normalize, format, caret};
